import React, {Component} from 'react'
import PropTypes from 'prop-types'
import styles from './MenuToggle.css'
import Svg from "../Svg/Svg"
import {Color, Icon, LIB} from "../../constants/consts-types"

class MenuToggle extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onMenuToggle: PropTypes.func.isRequired,
  }

  static defaultProps = {
    colors: {
      foreground: Color.GREY_LIGHT,
      background: Color.BLACK
    }
  }

  constructor(props) {
    super(props)

    this.onKeyUp = this.onKeyUp.bind(this)
    this.onMenuClick = this.onMenuClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyUp)
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp)
  }

  onKeyUp(event) {
    if(!this.props.isOpen) return

    switch(event.key) {
      case 'Escape':
        this.props.onMenuToggle()
        break
      default:
        break
    }
  }

  onMenuClick(event) {
    event.preventDefault()
    this.props.onMenuToggle()
  }

  render() {
    const {isOpen, colors} = this.props

    const styleToggle = {
      fill: isOpen ? colors.foreground : 'currentColor'
    }

    return (
      <button
        aria-label={isOpen ? LIB.close : LIB.menu}
        className={styles.MenuToggle}
        style={styleToggle}
        onClick={this.onMenuClick}
      >
        <div className={styles.bars}>
          <Svg id={Icon.MENU_TOGGLE_BAR} className={isOpen ? styles.bar1Open : styles.bar1}/>
          <Svg id={Icon.MENU_TOGGLE_BAR} className={isOpen ? styles.bar2Open : styles.bar2}/>
          <Svg id={Icon.MENU_TOGGLE_BAR} className={isOpen ? styles.bar3Open : styles.bar3}/>
        </div>
      </button>
    )
  }
}

export default MenuToggle



// WEBPACK FOOTER //
// ./src/components/MenuToggle/MenuToggle.js